<div *ngIf="showSummary" class="game-summary">
    <h1 class="summary-header">
        <span class="sr-only">{{programName}}</span>
        <img loading="lazy" alt="" class="summary-logo" src="{{desktopLogo}}">
        <img loading="lazy" alt="" class="mobile-summary-logo" src="{{mobileLogo}}">
    </h1>
    <div role="text" tabindex="0" class="summary-container">
        <div *ngIf="headline != ''" class="summary-container-info title-md-bold" [innerHtml]="headline "></div>
        <div *ngIf="personalizedXFContent != ''" [outerHTML]="personalizedXFContent | safeHtml"></div>
        <div *ngIf="summaryXFContent != ''" [outerHTML]="summaryXFContent | safeHtml"></div>
        <div class="game-feedback-info word-highlight-reg">
            {{footer}}   
        </div>
        <div *ngIf="surveyLink != ''" class="game-feedback-info">
            <button class="btn btn-lg btn-secondary"><a class="survey-link" target="_blank" href="{{surveyLink}}">Take the survey</a></button>
        </div>
    </div>
</div>
<div *ngIf="showListEmpty" class="game-grid">
    <div  class="message" [innerHtml]="gameListEmptyMessage | safeHtml"></div>
</div>

